import React from 'react'
import "./Spinner.css"

function Spinner() {
  return (
    <div className='loader'>Spinner</div>
  )
}

export default Spinner